export default "__VITE_ASSET__a6865f10__"